"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppBaseCursorAbsent = isAppBaseCursorAbsent;
exports.encodeAppBaseCursor = encodeAppBaseCursor;
exports.decodeAppBaseCursor = decodeAppBaseCursor;
/**
 * The cursor of a page of rows, as a pure codec over strings: no Buffer and no
 * secret. A call without a cursor, with `null` or with an empty text starts
 * at the first page, on the platform and in the StreamKit. The platform signs
 * its cursors on top; the StreamKit hands out the payload as it is.
 */
function isAppBaseCursorAbsent(raw) {
    return raw === undefined || raw === null || raw === '';
}
/** `payload` as unpadded base64url of its JSON in UTF-8. */
function encodeAppBaseCursor(payload) {
    let binary = '';
    for (const byte of new TextEncoder().encode(JSON.stringify(payload)))
        binary += String.fromCharCode(byte);
    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}
/** The payload of a cursor, or `null` for a text that carries none. */
function decodeAppBaseCursor(raw) {
    if (typeof raw !== 'string' || !/^[A-Za-z0-9_-]+$/.test(raw))
        return null;
    try {
        const binary = atob(raw.replace(/-/g, '+').replace(/_/g, '/') +
            '='.repeat((4 - (raw.length % 4)) % 4));
        const payload = JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(Uint8Array.from(binary, character => character.charCodeAt(0))));
        return payload && typeof payload === 'object' && !Array.isArray(payload)
            ? payload
            : null;
    }
    catch {
        return null;
    }
}
